import { c as _c } from "react/compiler-runtime";
import setFieldTouched from 'final-form-set-field-touched';
import React from 'react';
import { Field, Form } from 'react-final-form';
import Button from '../../button';
import FormError from '../../form-error';
import HelpText from '../../form-help-text';
import { Box, Flex, Grid } from '../../grid';
import Label from '../../label';
import RadioInput from '../../radio-button';
import { useIsDatalistValid } from '../hooks';
import { ClientFieldReference, DataSourceField, FieldPrefixContext, HelpTextField, LabelField, NameField, PrivateField, RequiredField, useOptionItems } from '../shared';
import arrayMutators from 'final-form-arrays';
import { touchErrors } from '../../utils/form';
import { useUpdateEffect } from '../../hooks/use-update-effect';
const MultipleChoice = t0 => {
  const $ = _c(34);
  const {
    schema,
    disabled,
    menu,
    style,
    className,
    isCustom: t1
  } = t0;
  const isCustom = t1 === undefined ? false : t1;
  const prefix = React.useContext(FieldPrefixContext);
  const [items] = useOptionItems(schema);
  const t2 = isCustom && "custom_fields";
  let t3;
  if ($[0] !== prefix || $[1] !== schema.name || $[2] !== t2) {
    t3 = [prefix, t2, schema.name].filter(_temp);
    $[0] = prefix;
    $[1] = schema.name;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const name = t3.join(".");
  let t4;
  if ($[4] !== schema.required) {
    t4 = value => {
      if (schema.required && (!value || !value.length)) {
        return "Select an option";
      }
    };
    $[4] = schema.required;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== menu || $[7] !== schema.label) {
    t5 = t6 => <Flex mb={2} justifyContent="space-between"><Label sx={{
        flexGrow: 1
      }}>{schema.label}</Label>{menu}</Flex>;
    $[6] = menu;
    $[7] = schema.label;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== name || $[10] !== t4 || $[11] !== t5) {
    t6 = <Field name={name} validate={t4}>{t5}</Field>;
    $[9] = name;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== disabled || $[14] !== items || $[15] !== name) {
    let t8;
    if ($[17] !== disabled || $[18] !== name) {
      t8 = (t9, idx_0) => {
        const {
          value: value_0,
          label
        } = t9;
        return <Box as="label" mb={2} key={idx_0} display="block"><Field type="radio" name={name} value={value_0} tabIndex={disabled ? -1 : undefined}>{_temp3}</Field>{" "}{label}</Box>;
      };
      $[17] = disabled;
      $[18] = name;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    t7 = items.filter(_temp2).map(t8);
    $[13] = disabled;
    $[14] = items;
    $[15] = name;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[20] !== schema.required) {
    t8 = value_1 => {
      if (schema.required && (!value_1 || !value_1.length)) {
        return "Select an option";
      }
    };
    $[20] = schema.required;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== schema.helptext) {
    t9 = t10 => {
      const {
        meta: meta_0
      } = t10;
      return <Box>{meta_0.error && <FormError>{meta_0.error}</FormError>}{schema.helptext && <HelpText>{schema.helptext}</HelpText>}</Box>;
    };
    $[22] = schema.helptext;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== name || $[25] !== t8 || $[26] !== t9) {
    t10 = <Field name={name} validate={t8}>{t9}</Field>;
    $[24] = name;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== className || $[29] !== style || $[30] !== t10 || $[31] !== t6 || $[32] !== t7) {
    t11 = <Box style={style} className={className}>{t6}{t7}{t10}</Box>;
    $[28] = className;
    $[29] = style;
    $[30] = t10;
    $[31] = t6;
    $[32] = t7;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  return t11;
};
export default MultipleChoice;
export const toString = value => {
  return value || '';
};
export const View = t0 => {
  const $ = _c(2);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <Box>{value}</Box>;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const Edit = t0 => {
  const $ = _c(16);
  const {
    isEditing,
    className,
    isUniqueFieldName,
    hideRequired,
    showClientFieldReference,
    value,
    menu,
    style
  } = t0;
  const [showMore, setShowMore] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowMore(_temp4);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleMore = t1;
  const removable = value.removable;
  const wasTouchedRef = React.useRef(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      wasTouchedRef.current = false;
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== value) {
    t3 = [value];
    $[2] = value;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useUpdateEffect(t2, t3);
  const isDataListMissing = useIsDatalistValid(value.data_list_id);
  let t4;
  if ($[4] !== className || $[5] !== hideRequired || $[6] !== isDataListMissing || $[7] !== isEditing || $[8] !== isUniqueFieldName || $[9] !== menu || $[10] !== removable || $[11] !== showClientFieldReference || $[12] !== showMore || $[13] !== style || $[14] !== value) {
    t4 = <>{!isEditing ? <Form mutators={{
        ...arrayMutators,
        setFieldTouched
      } as any} onSubmit={_temp5} validate={() => {
        const errors = {};
        if (value.data_source === "data_list_id" && isDataListMissing) {
          errors.onlyField = "Missing data list";
        }
        return errors;
      }}>{t5 => {
          const {
            form
          } = t5;
          if (wasTouchedRef.current === false) {
            touchErrors(form);
            wasTouchedRef.current = true;
          }
          return <MultipleChoice schema={{
            ...value,
            name: "onlyField"
          }} disabled={true} menu={menu} style={style} className={className} />;
        }}</Form> : <Grid sx={{
        display: !isEditing ? "none" : null
      }}><LabelField prefix="" /><DataSourceField prefix="" />{!hideRequired && <RequiredField prefix="" />}<HelpTextField prefix="" />{showMore && <>{showClientFieldReference && removable && <PrivateField prefix="" />}<NameField prefix="" isUniqueFieldName={isUniqueFieldName} removable={removable} />{showClientFieldReference && removable && <ClientFieldReference prefix="" schema={value} />}</>}<Button onClick={toggleMore} size="small" width="100%" variant="outlined">{showMore ? "Show less ..." : "Show more ..."}</Button></Grid>}</>;
    $[4] = className;
    $[5] = hideRequired;
    $[6] = isDataListMissing;
    $[7] = isEditing;
    $[8] = isUniqueFieldName;
    $[9] = menu;
    $[10] = removable;
    $[11] = showClientFieldReference;
    $[12] = showMore;
    $[13] = style;
    $[14] = value;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
function _temp(v) {
  return v;
}
function _temp2(_, idx) {
  return idx < 100;
}
function _temp3(t0) {
  const {
    input: input_0
  } = t0;
  return <RadioInput {...input_0} data-sentry-element="RadioInput" data-sentry-component="_temp3" data-sentry-source-file="index.tsx" />;
}
function _temp4(v) {
  return !v;
}
function _temp5() {
  return null;
}